import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs, Link as MUILink, Typography, Stack } from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import { Link as RouterLink } from 'react-router-dom';

/**
 * BreadCrumbsWithIcons — lightweight, borderless breadcrumbs with optional icons.
 * Usage: <BreadCrumbsWithIcons items={[{key,label,to,Icon}, ...]} sx={{...}} />
 */
export default function BreadCrumbsWithIcons({ items = undefined, sx = {} }) {
  const defaultItems = [
    { key: 'home', label: 'Home', to: '/dashboard', Icon: HomeOutlinedIcon }
  ];

  const crumbs = items && items.length ? items : defaultItems;

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNextRoundedIcon fontSize="small" />}
      sx={{ display: 'flex', justifyContent: 'flex-start', py: 0.5, width: '100%', ...sx }}
    >
      {crumbs.map(({ key, label, to, Icon }) => {
        const content = (
          <Stack direction="row" spacing={1} alignItems="center">
            {Icon ? <Icon fontSize="small" color={to ? 'action' : 'primary'} /> : null}
            <Typography variant="body2" sx={{ fontWeight: to ? 400 : 600 }} color={to? "" : "text.primary"}>
              {label}
            </Typography>
          </Stack>
        );

        return to ? (
          <MUILink key={key} component={RouterLink} to={to} color="inherit">
            {content}
          </MUILink>
        ) : (
          <Stack key={key} direction="row" spacing={1} alignItems="center">
            {Icon ? <Icon fontSize="small" color={to ? 'action' : 'primary'} /> : null}
            <Typography variant="body2" sx={{ fontWeight: to ? 400 : 600 }} color={to? "" : "text.primary"}>
              {label}
            </Typography>
          </Stack>
        );
      })}
    </Breadcrumbs>
  );
}

BreadCrumbsWithIcons.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      to: PropTypes.string,
      Icon: PropTypes.elementType,
    })
  ),
  sx: PropTypes.object,
};

